/* =====================================================================
   ALL EDITABLE CONTENT LIVES HERE.
   Non-technical friendly: change the text between the quotes " ".
   Anything marked  [PLACEHOLDER]  is still unknown — please replace it
   with the real information about SUNDARAN KKM.
   (മാറ്റേണ്ട വാചകങ്ങൾ " " എന്ന ഉദ്ധരണികൾക്കുള്ളിൽ എഴുതിയാൽ മതി.)
   ===================================================================== */

export const PROFILE = {
  name: "Dr. Sundaran KKM",
  // Short honorific / role shown under the name
  title: "Congress Leader · Trade Unionist · Voice of Farmers & Workers",
  tagline: "A life spent in the front row of the people's struggles.",
  location: "Koithoorkonam, Thiruvananthapuram, Kerala, India",

  // Hero intro
  heroIntro:
    "Koithoorkanam Sundaran — known across the district as Sundaran KKM — " +
    "is a veteran of the Congress movement from Koithoorkonam, " +
    "Thiruvananthapuram. From the Youth Congress to the dairy farmers' " +
    "movement, he has spent decades organising workers, farmers and " +
    "ordinary people — and standing in front when it mattered most.",

  // Hero photo — the large portrait at the top of the page.
  photo: "/profile/sundaran.png",

  // About photo — shown further down, in the "About" section.
  aboutPhoto: "/profile/sundaran-about.png",

  // Logo shown next to the name in the header and footer.
  logo: "/logo.webp",

  // Contact details  — [PLACEHOLDER] replace with real ones
  phone: "+91 XXXXX XXXXX", // [PLACEHOLDER]
  email: "contact@example.com", // [PLACEHOLDER]

  // Social links
  facebook: "https://www.facebook.com/sundarankkm",
  youtube: "https://www.youtube.com/channel/UCFd0l_cIqsY8Tflmw494kQQ",
  instagram: "#", // [PLACEHOLDER] optional
};

// Short keywords that scroll across the marquee ticker under the hero.
export const VALUES = [
  "Dairy Farmers' Rights",
  "Workers' Welfare",
  "Youth Leadership",
  "Dalit Empowerment",
  "Interfaith Harmony",
  "Congress Movement",
];

// Quick impact numbers shown as a "by the numbers" ledger.
// These are his own words: ~200 days in prison, ~150 cases faced,
// ~25 still active — worn as proof of a life of struggle, not a burden.
export const STATS = [
  { value: "7", label: "Leadership Positions Held" },
  { value: "200", label: "Days in Prison for People's Causes" },
  { value: "150", label: "Cases Faced in Public Struggles" },
  { value: "25", label: "Cases Still Being Fought Today" },
];

// Longer biography paragraphs for the About section.
export const BIOGRAPHY = [
  "Dr. Sundaran KKM — Koithoorkanam Sundaran — is a veteran leader of the " +
    "Congress movement from Koithoorkonam, in the Pothencode region of " +
    "Thiruvananthapuram district, Kerala. Rising from the grassroots, he " +
    "has carried responsibility in almost every wing of the movement — " +
    "youth, trade union, farmer and party organisation alike.",
  "He has served as District President and later State Working President " +
    "of the Ksheera Karshaka Thozhilali Congress (the Dairy Farmers' " +
    "Workers Congress), State Secretary of the INTUC Young Workers " +
    "Council, District General Secretary of the Youth Congress, General " +
    "Secretary of the DCC, and District General Secretary of the " +
    "Bharathiya Dalit Congress.",
  "That life of struggle has come at a price he carries with pride: " +
    "around 200 days spent in prison and some 150 cases faced in the " +
    "course of agitations for the people — about 25 of which he continues " +
    "to fight today.",
  "Currently, he serves as Chairman of the Mathasauhartha Koottayma " +
    "(Interfaith Coalition), working to keep the region's communities " +
    "united across every line of faith.",
];

// What he works on — the "focus areas" cards.
// icon can be one of: Users, HeartHandshake, Sprout, GraduationCap,
// Stethoscope, HandHeart, Landmark, Megaphone  (see components.js icon map)
export const FOCUS_AREAS = [
  {
    icon: "Sprout",
    title: "Dairy Farmers' Movement",
    description:
      "As District President and later State Working President of the " +
      "Ksheera Karshaka Thozhilali Congress, he has fought for fair " +
      "treatment, welfare and dignity for dairy farmers and their workers.",
  },
  {
    icon: "Users",
    title: "Workers & Trade Unions",
    description:
      "As State Secretary of the INTUC Young Workers Council, he has " +
      "championed the rights of young workers and organised them within " +
      "the trade union movement.",
  },
  {
    icon: "Megaphone",
    title: "Youth Politics",
    description:
      "As District General Secretary of the Youth Congress, he brought " +
      "young people into public life and led them through the movement's " +
      "campaigns and agitations.",
  },
  {
    icon: "Landmark",
    title: "Congress Organisation",
    description:
      "As General Secretary of the DCC (District Congress Committee), he " +
      "has helped build and strengthen the party's organisation across " +
      "Thiruvananthapuram district.",
  },
  {
    icon: "HandHeart",
    title: "Dalit Empowerment",
    description:
      "As District General Secretary of the Bharathiya Dalit Congress, he " +
      "has stood for social justice and the dignity of the district's most " +
      "marginalised communities.",
  },
  {
    icon: "HeartHandshake",
    title: "Interfaith Harmony",
    description:
      "As the current Chairman of the Mathasauhartha Koottayma (Interfaith " +
      "Coalition), he brings people of every faith together for a united, " +
      "peaceful community.",
  },
];

// POSITIONS HELD — the ledger of responsibilities (പദവികൾ).
// `ml` is the Malayalam line shown alongside; `current: true` adds a
// "നിലവിൽ · Current" badge to that row.
export const POSITIONS = [
  {
    role: "District President",
    org: "Ksheera Karshaka Thozhilali Congress",
    note: "Dairy Farmers' Workers Congress",
    ml: "ക്ഷീര കർഷക തൊഴിലാളി കോൺഗ്രസ് · ജില്ലാ പ്രസിഡന്റ്",
  },
  {
    role: "State Working President",
    org: "Ksheera Karshaka Thozhilali Congress",
    ml: "ക്ഷീര കർഷക തൊഴിലാളി കോൺഗ്രസ് · സംസ്ഥാന വർക്കിംഗ് പ്രസിഡന്റ്",
  },
  {
    role: "State Secretary",
    org: "INTUC Young Workers Council",
    ml: "INTUC യങ് വർക്കേഴ്സ് കൗൺസിൽ · സംസ്ഥാന സെക്രട്ടറി",
  },
  {
    role: "District General Secretary",
    org: "Youth Congress",
    ml: "യൂത്ത് കോൺഗ്രസ് · ജില്ലാ ജനറൽ സെക്രട്ടറി",
  },
  {
    role: "General Secretary",
    org: "District Congress Committee (DCC)",
    ml: "DCC · ജനറൽ സെക്രട്ടറി",
  },
  {
    role: "District General Secretary",
    org: "Bharathiya Dalit Congress",
    ml: "ഭാരതീയ ദളിത് കോൺഗ്രസ് · ജില്ലാ ജനറൽ സെക്രട്ടറി",
  },
  {
    role: "Chairman",
    org: "Mathasauhartha Koottayma",
    note: "Interfaith Coalition",
    ml: "മതസൗഹാർദ്ദ കൂട്ടായ്മ · ചെയർമാൻ",
    current: true,
  },
];

// Timeline of milestones. Exact years aren't on record, so each stage of
// his public life is used instead — replace with real years if known.
export const MILESTONES = [
  {
    year: "Roots",
    title: "A son of Koithoorkonam",
    text:
      "Rooted in Koithoorkonam, in the Pothencode region of " +
      "Thiruvananthapuram — where his name and his politics both come " +
      "from — he was drawn early into the Congress movement.",
  },
  {
    year: "Youth Politics",
    title: "Rising through the Youth Congress",
    text:
      "Served as District General Secretary of the Youth Congress, " +
      "organising young people across the district, and went on to become " +
      "General Secretary of the DCC.",
  },
  {
    year: "Workers' Struggles",
    title: "Trade union & farmers' leadership",
    text:
      "Led young workers as State Secretary of the INTUC Young Workers " +
      "Council, and rose from District President to State Working " +
      "President of the Ksheera Karshaka Thozhilali Congress — a road " +
      "that cost him around 200 days in prison and 150 cases.",
  },
  {
    year: "Social Justice",
    title: "Bharathiya Dalit Congress",
    text:
      "As District General Secretary of the Bharathiya Dalit Congress, he " +
      "took the fight for dignity and equality to the communities that " +
      "needed it most.",
  },
  {
    year: "Today",
    title: "Chairman, Mathasauhartha Koottayma",
    text:
      "Now leads the Interfaith Coalition as its Chairman — keeping " +
      "communities united and continuing a lifetime of service to the " +
      "people.",
  },
];

// NEWS CUTOUTS — newspaper / media clippings.
// Put your scanned clipping images inside  public/news/  and reference them
// here. Placeholder images are provided so the layout looks complete.
export const NEWS_CLIPPINGS = [
  {
    image: "/news/clip-1.jpeg",
    title: "Community drive led by Sundaran", // [PLACEHOLDER]
    source: "Local Daily", // [PLACEHOLDER]
    date: "2024", // [PLACEHOLDER]
    link: "", // optional online article URL
  },
  {
    image: "/news/clip-2.jpeg",
    title: "Relief work appreciated", // [PLACEHOLDER]
    source: "Regional News", // [PLACEHOLDER]
    date: "2023", // [PLACEHOLDER]
    link: "",
  },
];

// FACEBOOK VIDEOS.
// Paste the full URL of each Facebook video post below. The site embeds them
// automatically using Facebook's official video plugin.
// Example url: "https://www.facebook.com/username/videos/1234567890/"
// Leave `url` empty ("") to show a placeholder card instead.
export const FB_VIDEOS = [
  {
    url: "https://www.facebook.com/reel/1674911373791745",
    caption: "Reel from the Facebook page", // [PLACEHOLDER] confirm/replace with the real occasion
  },
  {
    url: "https://www.facebook.com/reel/874760934945758",
    caption: "Reel from the Facebook page", // [PLACEHOLDER] confirm/replace with the real occasion
  },
  {
    url: "https://www.facebook.com/story.php?story_fbid=2467285540411264&id=100013895254971",
    caption: "Post from the Facebook page", // [PLACEHOLDER] confirm/replace with the real occasion
  },
];

// YOUTUBE CHANNEL.
// Fill in the channel details, then paste the full URL of each YouTube video
// below. Any standard YouTube link works — the site turns it into an embed:
//   https://www.youtube.com/watch?v=VIDEO_ID
//   https://youtu.be/VIDEO_ID
//   https://www.youtube.com/embed/VIDEO_ID
// Leave `url` empty ("") to show a placeholder card instead.
export const YOUTUBE = {
  channelUrl: "https://www.youtube.com/channel/UCFd0l_cIqsY8Tflmw494kQQ",
  channelName: "Sundaran KKM",
};

export const YOUTUBE_VIDEOS = [
  { url: "https://youtu.be/LbAMHhUrFYg", caption: "Community event highlights" },
  { url: "https://youtu.be/XeM39kaRIfM", caption: "Speech at a public gathering" },
  { url: "https://youtu.be/PqiFIQT8qLY", caption: "Relief work on the ground" },
];

// MALAYALAM TOUCHES (മലയാളം).
// Malayalam phrases woven through the site for a local touch.
// Every line is editable — tweak the wording as you like.
export const MALAYALAM = {
  name: "സുന്ദരൻ കെ.കെ.എം.", // the name in Malayalam script
  fullName: "കൊയ്ത്തൂർക്കോണം സുന്ദരൻ", // his full popular name
  selfIntro: "“ഞാൻ കൊയ്ത്തൂർക്കോണം സുന്ദരൻ”", // his own words — About section
  greeting: "എല്ലാവർക്കും സ്വാഗതം", // "Welcome, everyone" (hero)
  tagline: "ജനങ്ങൾക്കൊപ്പം, എന്നും മുന്നിൽ", // "With the people, always in front" (hero)
  photoPlate: "സേവനം · കൊയ്ത്തൂർക്കോണം", // caption under the hero photo
  contactLine: "നമുക്ക് ഒരുമിച്ച് നല്ലൊരു നാട് കെട്ടിപ്പടുക്കാം", // contact section
  thanks: "നന്ദി", // footer
  current: "നിലവിൽ", // "currently" — badge on the current position

  // A short Malayalam word shown next to each section heading.
  sections: {
    stats: "സമരജീവിതം", // a life of struggle
    about: "ജീവിതരേഖ", // life sketch
    positions: "പദവികൾ", // positions held
    work: "സേവന മേഖലകൾ", // areas of service
    journey: "പ്രയാണം", // journey
    news: "വാർത്തകളിൽ", // in the news
    videos: "വീഡിയോകൾ", // videos
    youtube: "വീഡിയോകൾ", // videos
    gallery: "ചിത്രശാല", // gallery
    contact: "ബന്ധപ്പെടുക", // contact
  },
};

// PHOTO GALLERY — everyday moments. Put images in public/gallery/.
// Captions below are written from what's visible in each photo — please
// edit any that should say something more specific (event name, people,
// occasion).
//
// Want a photo to show up bigger than the rest? Add  featured: true  to
// that entry (see photo-1, photo-9 and photo-13 below for examples). Any
// number of photos can be featured — remove the line to make one normal
// size again.
export const GALLERY = [
  { image: "/gallery/doctorate.jpeg", caption: "Conferred with a doctorate degree", featured: true },
  { image: "/gallery/photo-1.jpg", caption: "Receiving a memento at a felicitation", featured: true },
  { image: "/gallery/photo-2.jpg", caption: "Distributing groceries to families in need" },
  { image: "/gallery/photo-3.jpg", caption: "A family celebration" },
  { image: "/gallery/photo-4.jpg", caption: "Greeting a fellow party leader" },
  { image: "/gallery/photo-5.jpg", caption: "Honouring a party member with a memento" },
  { image: "/gallery/photo-6.jpg", caption: "Congratulating a young achiever" },
  { image: "/gallery/photo-7.jpg", caption: "With fellow community members" },
  { image: "/gallery/photo-8.jpg", caption: "With a senior party leader" },
  { image: "/gallery/photo-9.jpeg", caption: "Felicitated at a community programme", featured: true },
  { image: "/gallery/photo-10.jpeg", caption: "Presenting a gift at a community event" },
  { image: "/gallery/photo-11.jpeg", caption: "Distributing Ramzan relief kits" },
  { image: "/gallery/photo-12.jpeg", caption: "At an interfaith harmony gathering" },
  { image: "/gallery/photo-13.jpeg", caption: "Community kit distribution", featured: true },
  { image: "/gallery/photo-14.jpeg", caption: "Meeting with community representatives" },
];
